//2022制服選拔活動
export { getUniformGameInfo } from "./getUniformGameInfoServices";
export { getAllCandidates } from "./candidatesServices";
export { getCandidatesDetails } from "./candidatesDetailServices";
export { getCandidatesModal } from "./candidatesModalServices";
export { vote } from "./voteServices";
export { logShare } from "./logShareServices";
export { uploadImage } from "./uploadImageServices";
export { singUpForm } from "./singUpFormServices";
